var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"markets-dark"}},[_c('markets',{ref:"markets",attrs:{"columns":_vm.columns,"default-market":_vm.defaultMarket,"callback":_vm.closeModal,"shortNameTab":"","zone":_vm.zone}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }